module.exports = __webpack_public_path__ + "img/flag-en.5e9a8c08.png";